<template>
  <div class="combined-wrapper" :class="pollPositionClass">
    <!-- Combined Poll + QR Code Unit -->
    <div class="poll-qrcode-unit">
      <!-- QR Code Section -->
      <div v-if="hasValidQRCode" class="qrcode-section" :class="[pollPositionClass, { 'no-images': !hasOptionsWithImages }]">
        <div class="qrcode-container">
          <BaseQRCode class="qrcode-bg" preserveAspectRatio="none" />
          <img
            :src="item.enquete_qr_code.url"
            :alt="qrCodeAltText"
            class="qrcode-image"
            @error="onQRCodeError"
          />
        </div>
        <div class="participe-label">
          <ParticipeQRCode class="participe-bg" preserveAspectRatio="none" />
          <!-- <span>Participe!</span> -->
        </div>
      </div>

      <!-- Standard Poll Component -->
      <div class="poll-section">
        <CardTarjaEnqueteF1Sportv
          :item="item"
          :posicaoEnquete="posicaoEnquete"
          :isFullScreen="isFullScreen"
          :hideTitle="hideTitle"
          :hideOptionTitle="hideOptionTitle"
          />
      </div>
    </div>
  </div>
</template>

<script>
import CardTarjaEnqueteF1Sportv from './CardTarjaEnqueteF1Sportv.vue';
import BaseQRCode from '@/assets/tarjas/F1Sportv/BASE_QR_CODE.svg';
import ParticipeQRCode from '@/assets/tarjas/F1Sportv/PARTICIPE_QR_CODE.svg';

export default {
  name: 'CardTarjaEnqueteF1SportvWithQRCode',
  components: {
    CardTarjaEnqueteF1Sportv,
    BaseQRCode,
    ParticipeQRCode,
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    posicaoEnquete: {
      type: String,
      default: 'esquerda'
    },
    isFullScreen: {
      type: Boolean,
      default: false
    },
    hideTitle: {
      type: Boolean,
      default: false
    },
    hideOptionTitle: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    hasValidQRCode() {
      return this.item?.enquete_qr_code?.url && this.item.enquete_qr_code.url.trim() !== '';
    },
    hasOptionsWithImages() {
      return this.item?.enquete_opcoes?.some(opcao => opcao.url_imagem) || false;
    },
    qrCodeAltText() {
      return `QR Code - ${this.item?.dsc_titulo_enquete || 'Participe da Enquete'}`;
    },
    pollPositionClass() {
      const positionMap = {
        'esquerda': 'poll-left',
        'direita': 'poll-right',
        'centro': 'poll-center'
      };
      return positionMap[this.posicaoEnquete] || 'poll-left';
    }
  },
  methods: {
    onQRCodeError(event) {
      console.error('Error loading QR Code image:', event);
      this.$emit('qrcode-error', {
        url: this.item?.enquete_qr_code?.url,
        enqueteId: this.item?.id
      });
    }
  }
}
</script>

<style scoped lang="scss">
@font-face {
  font-family: "RigidSquareExtrabold";
  src: url("@/assets/tarjas/F1Sportv/RigidSquareExtrabold.ttf") format("truetype");
}

@font-face {
  font-family: "RigidSquareExtrabold_Italic";
  src: url("@/assets/tarjas/F1Sportv/RigidSquareExtrabold_Italic.ttf") format("truetype");
}

$qrcode-gap: 0px;
$qrcode-width: 156px; // QR image (140px) + container padding (16px)

.combined-wrapper {
  --participe-label-background-gradient: linear-gradient(to top, #f9e8dd, #fcfcfc);
  --participe-label-text: #450326;

  width: 100%;
  height: 100vh;
  display: flex;
  align-items: flex-end;
  position: relative;

  &.poll-left {
    justify-content: flex-start;
    padding-left: calc(40px + #{$qrcode-width} + #{$qrcode-gap});
  }

  &.poll-center {
    justify-content: center;

    .poll-qrcode-unit {
      margin-left: $qrcode-width;
    }
  }

  &.poll-right {
    justify-content: flex-end;
    padding-right: calc(40px + #{$qrcode-width} + #{$qrcode-gap});
  }
}

.poll-qrcode-unit {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  position: relative;
}

.poll-section {
  display: flex;
  align-items: flex-end;

  ::v-deep .troca-de-passes-sportv-container {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
}

.qrcode-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  flex-shrink: 0;
  margin-bottom: 85px;
  position: absolute;
  bottom: 0;
  right: calc(100% + #{$qrcode-gap});
  z-index: 1;

  &.poll-right {
    right: auto;
    left: calc(100% + #{$qrcode-gap});
  }

  &.no-images {
    right: calc(100% + #{$qrcode-gap});

    &.poll-right {
      right: auto;
      left: calc(100% + #{$qrcode-gap});
    }
  }
}

.qrcode-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px;
  width: 148px;
  height: 148px;
  position: relative;

  .qrcode-bg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: 100%;
    z-index: 0;
  }
}

.qrcode-image {
  width: 124px;
  height: 124px;
  object-fit: contain;
  position: relative;
  z-index: 1;
}

.participe-label {
  width: 148px;
  height: 44px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: -4px;
  position: relative;

  .participe-bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 0;
  }

  span {
    display: block;
    font-family: 'RigidSquareExtrabold', sans-serif;
    font-size: 18px;
    color: #ffffff;
    margin-bottom: 2px;
    position: relative;
    z-index: 1;
  }
}
</style>
